import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { OrganizationOutput } from '../model/organization.output';

export interface FetchOrganizationByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchOrganizationByIdsApiQuery extends ApiQuery<
	OrganizationOutput[],
	FetchOrganizationByIdsParams
> {
	client = 'iam';
	document = gql`
		query FetchOrganizationByIds($ids: [UUID]!) {
			fetchOrganizationByIds(ids: $ids) {
				id
				name
				fees
				status
				iconUrl
				logoUrl
				sectors
				description
				updateTimestamp
				creationTimestamp
				planPrice {
					amount
					currency
				}
				sessionPrice {
					amount
					currency
				}
				shortDescription
				style {
					font
					primaryColor
					primaryTextColor
					secondaryColor
					secondaryTextColor
					negativeColor
					positiveColor
					textColor
					textSecondaryColor
				}
				address {
					city
					address
					country
					postalCode
				}
				properties {
					name
					type
					value
				}
				paymentProviderSubscriptionId
			}
		}
	`;
	method = 'fetchOrganizationByIds';
}
